module.exports = __webpack_public_path__ + "static/media/what-nieuw.3744a6bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/About/07_Foto-Work-with-us/hq/what-nieuw.jpg
// module id = 742
// module chunks = 0